import Color from "../Core/Color.js";
import Frozen from "../Core/Frozen.js";

/**
 * A directional light source that originates from the Sun.
 *
 * @param {object} [options] Object with the following properties:
 * @param {Color} [options.color=Color.WHITE] The light's color.
 * @param {number} [options.intensity=2.0] The light's intensity.
 *
 * @alias SunLight
 * @constructor
 */
function SunLight(options) {
  var _options$color, _options$intensity;
  options = options !== null && options !== void 0 ? options : Frozen.EMPTY_OBJECT;
  /**
   * The color of the light.
   * @type {Color}
   * @default Color.WHITE
   */
  this.color = Color.clone((_options$color = options.color) !== null && _options$color !== void 0 ? _options$color : Color.WHITE);

  /**
   * The intensity of the light.
   * @type {number}
   * @default 2.0
   */
  this.intensity = (_options$intensity = options.intensity) !== null && _options$intensity !== void 0 ? _options$intensity : 2.0;
}
export default SunLight;